module.exports = __webpack_public_path__ + "media/frames/frame_natural_horizontal-fe2fab0f.jpg";